import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

import type { RatingScale } from '@core/candidate-evaluation-settings-types';
import { EvaluationRatingScoreComponent } from '@core/evaluations-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { InterviewEvaluationRatingComponent } from '@core/interview-results-ui';
import type { Placement } from '@core/placements-types';
import {
  BadgeComponent,
  CollapsedCardChildComponent,
  CollapsibleCardComponent,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';

import { CandidateOfferTooltipComponent } from '../candidate-offer-tooltip/candidate-offer-tooltip.component';
import type { PlacementActionsCollection } from '../candidate-profile-placements/types';
import { CollapsibleCardAnalyticsDirective } from '../collapsible-card/collapsible-card-analytics.directive';

@Component({
  selector: 'rt-candidate-profile-talent-pools',
  templateUrl: './candidate-profile-talent-pools.component.html',
  styleUrls: ['./candidate-profile-talent-pools.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CollapsibleCardComponent,
    BadgeComponent,
    CollapsedCardChildComponent,
    HeadingComponent,
    TranslatePipe,
    IconComponent,
    IconButtonComponent,
    RouterLink,
    TruncateComponent,
    OverlayOriginDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    InterviewEvaluationRatingComponent,
    EvaluationRatingScoreComponent,
    CollapsibleCardAnalyticsDirective,
    RtTooltip,
    CandidateOfferTooltipComponent,
  ],
})
export class CandidateProfileTalentPoolsComponent {
  protected readonly DropdownWidth = DropdownWidth;

  public candidateId = input.required<number>();
  public canManageCandidates = input.required<boolean>();
  public placements = input.required<Placement[]>();
  public talentPoolActions = input.required<PlacementActionsCollection>();
  public evaluationScale = input<RatingScale | null>(null);
  public hasEvaluationImprovements = input<boolean>(false);
  public removeClick = output<{
    placementId: number;
  }>();

  public removeFromTalentPool(placement: Placement) {
    this.removeClick.emit({ placementId: placement.id });
  }
}
